<template>
  <div class="verification-code">
    <Input
      v-model="code"
      class="verify-input"
      type="text"
      name="verifyCode"
      v-bind="$attrs"
      @input="$emit('input', code)"
    />
    <div v-if="geetestLoading" class="geetest-loading">
      <Loading size="sm" />
    </div>
    <span
      :class="{ 'obtain-button': true, disabled: !isValid }"
      @click.prevent="validateClickable"
    >
      {{ buttonText }}
    </span>
    <GeetestCheck
      ref="geetest"
      target=".panel"
      @validate-pass="geetestPass"
      @validate-error="geetestError"
      @ready="geetestLoading = false"
    />
  </div>
</template>
<script>
import { sendVerificationEmail, sendVerificationMessage } from 'apis/oauth'
import Input from 'com/Input'
import Loading from 'com/Loading'
import GeetestCheck from 'com/GeetestCheck'

const CD_SECONDS = 60
export default {
  name: 'VerificationCode',
  components: { Input, GeetestCheck, Loading },
  props: {
    value: String,
    type: 'email' | 'phone',
    username: String,
    process: {
      type: String,
      default: 'fast_signin'
    },
    verify: Function, // 自定义校验
    telCode: String | Number
  },
  model: {
    prop: 'value',
    event: 'on-change'
  },
  watch: {
    code(val) {
      this.$emit('on-change', val)
    },
    value(val) {
      this.code = val
    },
    params() {
      this.reset()
    }
  },
  data: () => ({
    code: null,
    timer: null,
    geetestLoading: false,
    geetestData: {}, // 极验结果
    countdown: CD_SECONDS
  }),
  computed: {
    isValid() {
      return this.username && this.countdown === CD_SECONDS
    },
    params() {
      if (this.type === 'phone') {
        return {
          tel_code: this.telCode,
          phone: this.username,
          process: this.process,
          voice: 0
        }
      }
      return {
        email: this.username,
        process: this.process
      }
    },
    buttonText() {
      if (this.countdown === CD_SECONDS) {
        return this.$t('login.get-code')
      } else {
        return this.countdown + 's'
      }
    }
  },
  mounted() {
    this.code = this.value
  },
  methods: {
    validateClickable() {
      if (!this.isValid) return
      if (this.verify) {
        const pass = this.verify(this.type, this.params)
        if (!pass) {
          return
        }
      }
      // 接入极验
      this.geetestLoading = true
      this.$refs.geetest.init()
    },
    async sendCode(geetest) {
      // 默认设置邮箱方式
      let sendRequest = sendVerificationEmail
      if (this.type === 'phone') {
        sendRequest = sendVerificationMessage
      }
      this.error = null
      this.startCountDown()
      const params = { ...this.params, ...geetest }
      try {
        const { data: respData } = await sendRequest(params)
        if (respData.is_succ) {
          this.$emit('success')
        } else {
          throw respData.data
        }
      } catch (err) {
        this.$emit('error', err)
        this.clearCountDown()
      }
    },
    geetestPass(data) {
      this.geetestData = data
      this.$emit('geetest-pass', data)
      this.sendCode(data)
    },
    geetestError(error) {
      this.$emit('error', error)
      this.geetestLoading = false
    },
    startCountDown() {
      this.clearCountDown()
      this.timer = window.setInterval(() => {
        this.countdown = this.countdown - 1
        if (this.countdown <= 0) this.clearCountDown()
      }, 1000)
    },
    clearCountDown() {
      window.clearInterval(this.timer)
      this.countdown = CD_SECONDS
    },
    reset() {
      this.clearCountDown()
      this.code = ''
      this.geetestData = {}
    }
  }
}
</script>
<style scoped lang="less">
@import '~uikit';
.verification-code {
  display: flex;
  align-items: center;
  position: relative;
  .obtain-button {
    width: 100px;
    height: 35px;
    padding: 0;
    line-height: 35px;
    border-radius: 0 2px 2px 0;
    text-align: center;
    cursor: pointer;
    background: var(--login-active-color);
    color: #ffffff;
    &.disabled {
      cursor: not-allowed;
      background: @disabled-color;
      color: @light-grey;
    }
  }
  .geetest-loading {
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 70px;
    height: 35px;
    right: 0;
    top: 0;
  }
}
</style>

<style lang="less">
.verification-code .tt-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
</style>
